export default __webpack_public_path__ + "static/media/Mark.0afe9bff.webp";